export default "__VITE_ASSET__b6bb8843__"